import React from 'react';
import {
  attachmentProblem,
  formatBytes,
  MAX_ATTACHMENTS
} from '../../../services/helpers/ticket-rules.helper';

interface Props {
  files: File[];
  onChange: (files: File[]) => void;
  disabled?: boolean;
}

/** Picked files as removable chips, plus the limit problem if there is one. */
export const TicketFilesInput: React.FC<Props> = ({ files, onChange, disabled }) => {
  const problem = attachmentProblem(files);
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-2">
        {files.map((file: File, index: number) => (
          <span
            key={`${file.name}-${index}`}
            className="inline-flex items-center gap-1.5 rounded-full bg-creams-200 px-2.5 py-0.5 text-xs text-neutral-500"
          >
            {file.name} · {formatBytes(file.size)}
            <button
              type="button"
              className="text-neutral-300 hover:text-secondary-700"
              aria-label={`Remove ${file.name}`}
              onClick={() => onChange(files.filter((_, i) => i !== index))}
            >
              ×
            </button>
          </span>
        ))}
        {files.length < MAX_ATTACHMENTS ? (
          <label className="cursor-pointer text-xs font-gilroy-medium text-primary-700 hover:underline">
            Attach files
            <input
              type="file"
              multiple
              className="hidden"
              disabled={disabled}
              onChange={(event) => {
                const picked = Array.from(event.target.files || []);
                event.target.value = '';
                onChange([...files, ...picked]);
              }}
            />
          </label>
        ) : null}
      </div>
      {problem ? <p className="text-xs text-secondary-700">{problem}</p> : null}
    </div>
  );
};
